import OBase from './OBase';
import * as Geometry from '../geometry';

export default class Rotate3D extends OBase {
  update () {
    let angleTree = this.getFloatInput('Angle');
    let geomInputTree = this.getObjectInput('Geometry');
    let centerTree = this.getVector3Input('Center', false);
    let axisTree = this.getVector3Input('Axis', false);

    let output = this.outputs['Geometry'].paramObject;

    let dataTrees = [angleTree, geomInputTree, centerTree, axisTree];
    let outDataTrees = [];
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        // let angle = -outDataTrees[0].branches[i][j] + Math.PI / 180.0 * 0.001
        let angle = outDataTrees[0].branches[i][j] + Math.PI / 180.0 * 0.001;
        let geomInput = outDataTrees[1].branches[i][j];
        let center = outDataTrees[2].branches[i][j];
        let axis = outDataTrees[3].branches[i][j];

        // console.log(geomInput, angle, center, axis)

        if (geomInput instanceof THREE.Geometry) {
          let g = geomInput.clone();
          g.vertices.forEach(v => {
            v.set(v.x - center.x, v.y - center.y, v.z - center.z);
            v.applyAxisAngle(axis, angle);
            v.set(v.x + center.x, v.y + center.y, v.z + center.z);
          });
          outTree.add(g, outDataTrees[0].paths[i]);
        } else {
          let paths = geomInput;

          let rotatedPaths = [];
          for (let k = 0; k < paths.length; k++) {
            let path = paths[k];
            rotatedPaths.push([]);
            for (let t = 0; t < path.length; t++) {
              let pt = path[t];
              // let movedIntPt = new ClipperLib.IntPoint(pt.X - plane.center.x, pt.Y - plane.center.z)
              let rotatePt = new ClipperLib.DoublePoint(pt.X - center.x, pt.Y - center.y);
              let p = new THREE.Vector3(rotatePt.X, rotatePt.Y, 0);
              p.applyAxisAngle(axis, angle);
              rotatePt = new ClipperLib.DoublePoint(p.x + center.x, p.y + center.y);
              rotatedPaths[k].push(rotatePt);
            }
          }

          /*
          console.log('---Rotate---')
          console.log(paths)
          console.log(angle, plane.center, plane.normal, plane.name)
          console.log(rotatedPaths)
          */

          outTree.add(rotatedPaths, outDataTrees[0].paths[i]);
        }
      }
    }
    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Rotate3D.js